module.exports = __webpack_public_path__ + "static/media/allergy_slider_phone3.d2cf8968.png";